export const deepClone = (targetObj: any) => {
  // 深拷贝
  let tempObj: any
  if (typeof targetObj === 'object') {
    if (targetObj === null) {
      tempObj = null
    } else {
      if (targetObj instanceof Date) {
        tempObj = targetObj
      } else if (targetObj instanceof Array) {
        tempObj = []
        for (let i = 0, len = targetObj.length; i < len; i++) {
          tempObj.push(deepClone(targetObj[i]))
        }
      } else {
        tempObj = {}
        for (const j in targetObj) {
          tempObj[j] = deepClone(targetObj[j])
        }
      }
    }
  } else {
    tempObj = targetObj
  }
  return tempObj
}
